import { api } from '../lib/api'

export type ImpactVerdict = 'improved' | 'worsened' | 'flat' | 'pending'

export interface ImpactAction {
  id: string
  type: 'optimization' | 'derived'
  description: string
  category: string
  clientId: string
  clientName: string
  managerId: string
  managerName: string
  weekStart: string // YYYY-MM-DD (semana do relatório da ação)
  doneAt: string | null // ISO
  metric: string
  metricLabel: string
  betterWhen: 'higher' | 'lower'
  source: 'ai' | 'category' // métrica marcada pela IA ou inferida pela categoria
  // Onde foi medido: campanha da ação → plataforma → consolidado.
  platform: 'google_ads' | 'meta_ads' | null
  campaign: string | null
  scope: 'campaign' | 'platform' | 'account'
  scopeLabel: string
  note: string | null // ex.: "pouco volume: 4 conversões (mínimo 10)"
  before: number | null
  after7: number | null // ~7d depois (próximo relatório)
  after14: number | null // ~14d depois (2 relatórios depois)
  verdict7: ImpactVerdict
  verdict14: ImpactVerdict
}

export const impactApi = {
  list: (clientId?: string) =>
    api.get<{ actions: ImpactAction[] }>(`/impact${clientId ? `?clientId=${encodeURIComponent(clientId)}` : ''}`),
}
